import { render } from "./OcTabBar.vue?vue&type=template&id=7f8bd4b9"
import script from "./OcTabBar.vue?vue&type=script&lang=js"
export * from "./OcTabBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__